/** The portal builder stores manual-label instructions one per line. */
export function manualLabelInstructionLines(
  text: string | null | undefined,
): string[] {
  return (text ?? "")
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter(Boolean);
}

/**
 * The portal confirmation page's instructions, else the legacy Settings →
 * Shipping instructions, else `defaults`.
 */
export function resolveManualLabelInstructions({
  portalText,
  legacy,
  defaults,
}: {
  portalText: string | null | undefined;
  legacy: readonly (string | null | undefined)[] | null | undefined;
  defaults: readonly string[];
}): string[] {
  const portal = manualLabelInstructionLines(portalText);
  if (portal.length) {
    return portal;
  }
  const configured = (legacy ?? []).filter(
    (instruction): instruction is string => !!instruction?.trim(),
  );
  return configured.length ? configured : [...defaults];
}
